import { Link } from 'react-router-dom'
import { Button } from '../ui/Button'

const footerLinks = [
  { to: '/services/managed-it', label: 'Managed IT' },
  { to: '/services/ai-automation', label: 'AI Automation' },
  { to: '/services/ai-automation/compare', label: 'AI Comparison' },
  { to: '/security', label: 'Security' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/about', label: 'About' },
  { to: '/blog', label: 'Blog' },
]

export function Footer() {
  return (
    <footer
      className="py-16 px-6 border-t"
      style={{ backgroundColor: 'var(--bg-2)', borderColor: 'var(--accent-line)' }}
    >
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
        {/* Column 1 — Brand */}
        <div>
          <img src="/NTC-LOGO-WHITE.svg" alt="NextTech Consultants" width={158} height={28} className="h-7 w-auto mb-2" />
          <p className="text-cream-dim text-base mb-4">Technology That Just Works.</p>
          <p className="text-cream-dim text-base">971.238.4801</p>
          <p className="text-cream-dim text-base">info@nexttechconsultants.com</p>
          <p className="text-cream-dim text-base mt-2">Serving the Portland Metro &amp; Pacific Northwest</p>
          <p className="text-cream-dim text-base">Hillsboro · Tigard · Vancouver · McMinnville · Newberg</p>
        </div>

        {/* Column 2 — Services */}
        <div>
          <p className="font-body font-semibold text-white mb-4">Services</p>
          <ul className="space-y-2">
            {footerLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-cream-dim hover:text-white text-sm transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 3 — Get Started */}
        <div>
          <p className="font-body font-semibold text-white mb-4">Get Started</p>
          <Button to="/contact" variant="primary" fullWidth>
            Book a Free Discovery Call
          </Button>
          <p className="text-cream-dim text-base mt-4">Or call us: 971.238.4801</p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-12 pt-8 border-t flex flex-col sm:flex-row justify-between items-center gap-4" style={{ borderColor: 'var(--accent-line)' }}>
        <p className="text-cream-faint text-sm">© 2025 NextTech Consultants. All rights reserved.</p>
        <div className="flex items-center gap-4">
          <Link to="/privacy" className="text-cream-dim hover:text-white text-sm transition-colors">
            Privacy Policy
          </Link>
          <Link to="/sms-terms" className="text-cream-dim hover:text-white text-sm transition-colors">
            SMS 2FA Terms
          </Link>
          <Link to="/sms-marketing-terms" className="text-cream-dim hover:text-white text-sm transition-colors">
            SMS Marketing Terms
          </Link>
        </div>
      </div>
    </footer>
  )
}
